const state = {
  darkModeSwitch: false,
  mobileMenuSwitch: false,
  onToolBar: false,
  clickedPlan: null
};

const mutations = {
  setDarkMode(state, toggleState) {
    state.darkModeSwitch = toggleState;
  },
  setMobileMenu(state, toggleState) {
    state.mobileMenuSwitch = toggleState;
  },
  setToolBar(state, toggleState) {
    state.onToolBar = toggleState;
  },
  toggleToolBar(state) {
    state.onToolBar = !state.onToolBar;
  },
  setClickedPlan(state, plan) {
    state.clickedPlan = plan;
  }
};

const getters = {
  getThemeMode: state => {
    return state.darkModeSwitch;
  },
  getToolBarMode: state => {
    return state.onToolBar;
  },
  getClickedPlan: state => {
    return state.clickedPlan;
  }
};

const actions = {
  toggleDarkMode({ commit }, toggleState) {
    // Storing in local storage
    localStorage.setItem("setDarkMode", JSON.stringify(toggleState));
    commit("setDarkMode", toggleState);
  },
  toggleMobileMenu({ commit }, toggleState) {
    if (toggleState === true) {
      document.body.style.overflow = "hidden";
    } else if (toggleState === false) {
      document.body.style.overflow = "unset";
    }
    commit("setMobileMenu", toggleState);
  },
  toggleToolBar({ commit }, toggleState) {
    if (toggleState === undefined) {
      return commit("toggleToolBar");
    }

    commit("setToolBar", toggleState);
  },
  setClickedPlan({ commit }, toggleState) {
    commit("setClickedPlan", toggleState);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
